import { AccentText, ButtonKangourou, DescriptionCreator, DescriptionHero, DescriptionPrivacy, DescriptionScope, DescriptionSubscribe, IconHexagon, ItemOption, LinkKangourou, ListOption, LogoKangourouDescription, MainTitle, SectionCreator, SectionScope, SectionSubscribe, SectionTitle, TitleSubscribe, WrapperCreator, WrapperDescription, WrapperDescriptionCreator, WrapperHero, WrapperImg, WrapperLogoPencil, WrapperSection } from "./About.styled";
import hero from '../assets/images/hero600quadrat.jpg';
import logoPencil from '../assets/images/logoPencil.png';
import logoCangourou from '../assets/images/kangourou.png';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { META_DATA } from "../utils/constants";
import { Button } from "@mui/material";
import { useEffect } from "react";
import { handleScrollUp } from "../utils/helpers";

const About = () => { 
    const { title, description, keywords } = META_DATA?.about;
    
    useEffect(() => {
        handleScrollUp(); 
        localStorage.clear();
    }, [])
    
    return ( 
        <>
        <Helmet>
                <title>{title}</title>
        <meta name="keywords" content={keywords} />                
        <meta name="description" content={description} />
      </Helmet>
        <WrapperSection>
        <section>                
                <WrapperHero>                    
                    <WrapperDescription>
                        <MainTitle>Mathlab: Preparati per i Giochi Matematici!</MainTitle>              
                <DescriptionHero>
                    Benvenuti in Mathlab! Questa app è stata creata per tutti gli studenti
                    appassionati di matematica che desiderano mettersi alla prova e affrontare le sfide matematiche
                    in modo divertente e interattivo. È ideale sia per i ragazzi che desiderano migliorare le loro abilità,
                    che per gli insegnanti che cercano uno strumento efficace per l'allenamento dei alunni.
                    </DescriptionHero>
                    </WrapperDescription>
                    <WrapperImg>
                        <img src={hero} width="600" height="600" alt="Hero image" />
                    </WrapperImg>
                    </WrapperHero>
        </section>            
            <SectionScope>             
                <SectionTitle>Scopo dell'app</SectionTitle>
                <DescriptionScope>
                    <span>
                        Il nostro obiettivo principale è fornire un ambiente di apprendimento coinvolgente e
                    stimolante per gli studenti, permettendo loro di esercitarsi con centinaia di quiz basati
                        sulle domande dei giochi matematici </span>
                    <LinkKangourou to='https://www.kangourou.it/' target="_blank" rel="noopener noreferrer">
                        Kangourou Italia
                    </LinkKangourou>
                        <span>. Inizia la tua avventura matematica! Accedi alla voce del menu <AccentText>simulazione</AccentText> nella pagina Home,
                            scegli la tua categoria e l'anno della competizione desiderata. Oppure clicca qui sotto
                    </span>
                    </DescriptionScope>
                    <ButtonKangourou component={Link} to="/simulation">
                        <img src={logoCangourou} width="70" height="70" alt="Logo Kangourou" />                        
                    </ButtonKangourou>              
            </SectionScope>
            <SectionCreator>
                <SectionTitle>Crea i tuoi Quiz personalizzati</SectionTitle>
                <WrapperCreator>  
                    <WrapperLogoPencil>
                        <img src={logoPencil} width="200" alt="Logo" />
                    </WrapperLogoPencil>
                    
                    <WrapperDescriptionCreator>
                <DescriptionCreator>
                                {/* Con la nostra funzione avanzata, puoi personalizzare completamente il tuo
                                allenamento. Vai alla pagina Home, scegli la tua categoria, il numero di
                                domande, il livello di difficoltà e se allenarti con il timer o senza.
                                Inizia subito! */}
                                <p>Con la nostra funzione avanzata, puoi personalizzare completamente il tuo
                                allenamento. Vai alla pagina Home, scegli la tua categoria e:</p>
                                <ListOption>
                                    <ItemOption><IconHexagon/>definisci il numero di domande</ItemOption>
                                    <ItemOption><IconHexagon/>seleziona il livello di difficoltà</ItemOption>
                                    <ItemOption><IconHexagon/>attiva o disattiva il timer</ItemOption>
                                </ListOption>
                                <p>Crea l'esperienza di apprendimento perfetta per te!</p>
                    </DescriptionCreator>
                    <Button component={Link} to="/" color="primary" variant="outlined">vai alla home</Button>
                   </WrapperDescriptionCreator>
                </WrapperCreator>
            </SectionCreator>
            <SectionSubscribe>
                <TitleSubscribe>Iscriviti ai Giochi Matematici Kangourou:</TitleSubscribe>
                <p>
                    <span>Unisciti a migliaia di studenti entusiasti e partecipa ai Giochi Matematici Kangourou!
                    È un'opportunità eccitante per mettere alla prova le tue abilità matematiche a livello
                        nazionale. Per maggiori informazioni e per iscriverti, visita il sito ufficiale dei </span>
                    <LinkKangourou to='https://www.kangourou.it/' target="_blank" rel="noopener noreferrer">
                       Kangourou Italia
                    </LinkKangourou>
                </p>
                <LogoKangourouDescription>
                    <Link to='https://www.kangourou.it/' target="_blank" rel="noopener noreferrer">
                     <img src={logoCangourou} width="200" alt="Logo Kangourou" />
                    </Link>                
                <DescriptionSubscribe>
                    Kangourou Italia è il partner principale di mathlab.it e ci consente di utilizzare
                    i loro quiz ufficiali. 
                    </DescriptionSubscribe>
                    </LogoKangourouDescription>
                </SectionSubscribe> 
                <DescriptionPrivacy>
                    Per maggiori informazioni su come gestiamo i tuoi dati, consulta la nostra
                    <Button component={Link} to={'/general-conditions'}  color='base'>Informativa sulla Privacy</Button>
                </DescriptionPrivacy>
                
            </WrapperSection>
            </>
    )

};

export default About;